<template>
  <fragment>
    <span v-if="isTitleVisible" class="font_Montserrat font_size_1000rem v3_color_black_knight1">
      {{ title }}
    </span>
    <div class="survey-results-chart-pie" :class="{'border_1 border_grey' : isBorderVisible}">
      <highcharts :options="chartOptions" />
    </div>
    <template v-if="isStatsVisible">
      <div
        v-if="responsesCount"
        class="text-right survey-results__responses-count mt-1"
      >
        <span>N = {{ responsesCount | formatNumber }}</span>
      </div>
    </template>
  </fragment>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import FormatNumberFilterMixin from '@/mixins/FormatNumberFilterMixin';
import ChartsFormatterMixin from '@/mixins/ChartsFormatterMixin';
import { getCharHeightForChartTypeAndWidth } from '@/helpers/chartsHelper';

export default {
  name: 'SurveyResultsChartPie',
  mixins: [FormatNumberFilterMixin, ChartsFormatterMixin],
  components: {
    highcharts: Chart,
  },
  props: {
    title: String,
    questionType: String,
    results: Array,
    format: String, // 'dashboard' / 'results' / 'filters' / 'no-study-completed' / 'job-question'
    responsesCount: [Number, String],
    isPercentage: {
      type: Boolean,
      default: false,
    },
    isStatsVisible: {
      type: Boolean,
      default: true,
    },
    isTitleVisible: {
      type: Boolean,
      default: true
    },
    isBorderVisible: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    windowWidth: function () {
      this.updateChartHeight();
    },
    results() {
      // refresh data series
      this.chartOptions.series[0].data = this.results.map((r) => {
        return {
          name: this.getDataPointName(r),
          y: +r.value_count,
        };
      });
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          backgroundColor: 'transparent',
          events: {
            render: () => this.$emit('chart-rendered'),
          },
          type: 'pie',
          height: getCharHeightForChartTypeAndWidth(
            this.type,
            this.windowWidth
          ),
          // width: 700
        },
        title: undefined,
        tooltip: {
          headerFormat: '',
          pointFormat: this.isPercentage
            ? '<b>{point.name}, {point.percentage:.1f}%</b>'
            : '<b>{point.name}, {point.y}</b>',
        },
        legend: { enabled: false },
        credits: { enabled: false },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            colors: this.pieColors(),
            dataLabels: {
              enabled: true,
              formatter: this.getDataLabelsFormatter(),
            },
          },
          series: {
            color: '#5AC3D8',
          },
        },
        series: [
          {
            data: this.results.map((r) => {
              return {
                name: this.getDataPointName(r),
                y: +r.value_count,
              };
            }),
          },
        ],
      },
    };
  },
  methods: {
    pieColors() {
      var colors = [],
        base = Highcharts.getOptions().colors[0],
        i;

      for (i = 0; i < 10; i += 1) {
        // Start out with a darkened base color (negative brighten), and end
        // up with a much brighter color
        colors.push(
          Highcharts.Color(base)
            .brighten((i - 5) / 7)
            .get()
        );
      }
      return colors;
    },
    updateChartHeight: function () {
      this.chartOptions.chart.height = getCharHeightForChartTypeAndWidth(
        this.format,
        this.windowWidth
      );
    },
  },
  created: function () {
    this.updateChartHeight();
  },
};
</script>

<style lang="scss"></style>
